export const PREFERRED_LANGUAGE = "preferredLanguage";

export const ENGLISH = "en";
export const FRANÇAIS = "fr";
export const FRANÇAIS_SPELLED_OUT = "Français";
export const ENGLISH_SPELLED_OUT = "English";
